import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import Loading from "../../components/Loading.js";
import Marquii from "../../components/Marquii.js";

import About from "./About.js";
import Premium from "./Premium.js";
import Values from "./Values.js";
import Why from "./Why.js"
// import Clients from "./Clients.js";
import Reviews from "./Reviews.js";
// import Gallery from "./Gallery.js";
import Contact from "./Contact.js";
import Location from "./Location.js";

import DATA from '../data/_entity.json'; // assert {type: 'json'}
import DATAG from "../data/_gallery.json";

import homeImg from "../../assets/images/home.png"
import logo from "../../assets/images/logo.png"
import vid1 from "../../assets/images/ice-vid1.mp4";

import "./_home.css";


const Home = ({ APPDATA }) => {
  const [err, setErr] = useState("Site is Loading...");
  let location = useLocation();
  const [hash, setHash] = useState("")

  const showGallery = () => {
    // window.location.assign("/gallery"); //!working
    window.location = "gallery"; //!working
    // <Link to={"gallery"}></Link>
  }

  // window.scrollTo(0, 0);
  useEffect(() => {
    if (location.hash) {
      setHash(document.getElementById(location.hash.slice(1)));
      hash && hash.scrollIntoView({ behavior: "smooth", inline: "nearest" })
    }
    return () => {
    }
  }, [hash, location.hash])


  useEffect(() => {
    setErr("");
    return () => { };
  }, []);

  return (
    <div className="page-container" >
      {err ? (
        <Loading text={err} />
      ) : (
        <>
          <div className="page-box col-10" >

            <div className="page-img">
              <video width="100%" autoPlay muted loop poster={homeImg} style={{ marginTop: "-40%" }} onPlay={(e) => {
                e.target.playbackRate = 0.6
              }}>
                <source src={vid1} type="video/mp4" />
                Your browser does not support Video.
              </video>
            </div>

            <div className="home-title-frame" >
              <img className="home-logo" src={logo} alt="homelogo"></img>
              <br />
              <span className="home-title" >{DATA.entity.subtitle}</span>
              <place-holder id="about" />
            </div >

            <About APPDATA={APPDATA} />
            <div className="hashtags">
              {DATA.entity.hashtags.map((key) => {
                return (
                  (key[0] === "#" ? "" : "#") + key + " "
                )
              })
              }
            </div>
          </div>

          <div className="page-box col-10" >

            <place-holder id="premium" />
            <div className="sections">
              <Premium />
            </div>

            <place-holder id="why" />
            <div className="sections" id="values">
              <Values />
            </div >
            <div className="sections" >
              <Why />
            </div>

            <div className="sections" id="clients">
              {/* <Clients /> */}
              <Reviews />
              {/* <Gallery /> */}
              {/* <h2>&nbsp;Gallery</h2> */}
              <Marquii
                title="Click to view Gallery"
                id="marquii-gallery"
                overlay={<div onClick={showGallery} aria-hidden>Visit Gallery</div>}
              >
                {Object.keys(DATAG.gallerySlider).map((key) => {
                  return (
                    <div className="slides" key={key}>
                      <img src={`gallery1/${DATAG.gallerySlider[key][0]}`} alt={key}></img>
                    </div>
                  );
                })
                }
              </Marquii>

            </div>

            <place-holder id="contact" />
            <div className="sections" >
              <Contact />
            </div>
            <div className="sections">
              <Location />
            </div>

          </div>
        </>
      )
      }
    </div >
  );
};

export default Home;